import { icon } from '@fortawesome/fontawesome-svg-core';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
/**
 * Icon component that renders a material symbol icon.
 *
 * @param {Object} props - The properties object.
 * @param {string} props.name - The name of the icon to be displayed.
 * @param {boolean} [props.bold] - Optional flag to render the icon in bold style.
 * @param {string} [props.className] - Optional additional class names to apply to the icon.
 * @returns {JSX.Element} The rendered icon component.
 */
const Icon = (props) => {
  const { name, bold = false, className } = props;
  const [debouncedValue, setDebouncedValue] = useState(name);
  const classes = cx('icon material-symbols-rounded', { bold }, className);
  const regex = /\bfa[srbld]?-[a-z0-9-]+\b/g;
  const matches = debouncedValue.match(regex);

  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(name);
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [name]);

  if (matches?.length > 0) {
    const sliptedMatch = matches[0].split('-');
    const Iconprefix = sliptedMatch[0] === 'far' ? 'fas' : sliptedMatch[0];
    const nameIcon = sliptedMatch.reduce((acc, current, index) => {
      if (index === 1) {
        return acc + current;
      }
      if (index > 1) {
        return acc + '-' + current;
      }
      return acc;
    }, '');

    const findIcon = icon({
      prefix: Iconprefix,
      iconName: nameIcon,
    });

    if (findIcon && isClient) {
      return (
        <FontAwesomeIcon
          size="2x"
          className={className.replace('icon', 'fontawesome')}
          icon={[Iconprefix, nameIcon]}
        />
      );
    }

    return null;
  }
  return <span className={classes}>{name}</span>;
};

export default Icon;

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  bold: PropTypes.bool,
  className: PropTypes.string,
  iconLibrary: PropTypes.string,
};
